import type { ComponentChildren } from 'preact';
import './StatusBadge.css';

type Tone = 'accent' | 'ok' | 'warn' | 'error' | 'info' | 'neutral';

interface Props {
  tone?: Tone;
  children: ComponentChildren;
  title?: string;
}

/** Small pill for status/capability labels. No icon — text is the payload. */
export function StatusBadge({ tone = 'neutral', children, title }: Props) {
  return <span class={`hv-badge hv-badge--${tone}`} title={title}>{children}</span>;
}
